export default "__VITE_ASSET__73c390d0__"